namespace TR {

    import IRouteParamsService = angular.route.IRouteParamsService;
    import IScope = angular.IScope;
    import TripService = Core.TripService;
    import TripState = Core.Trip.TripState;
    import IRootScopeService = angular.IRootScopeService;
    class HotelOptions {
        tripId: string | undefined;
        basketId: string | undefined;

        children: number = 0;
        hotel;
        transfer;
        optionConditions;
        totalCost;
        payDirectAmount: number;
        paymentData;
        basketRules;
        totalDeposit: number;
        costBreakdown;

        durationSummary: string;
        additionalInformation;

        attractionsExtraEnabled: boolean;
        loading = true;
        submitted = false;

        constructor(
            private $routeParams,
            $rootScope,
            $scope: IScope,
            private $q: ng.IQService,
            searchUnitService,
            private basketStore,
            tripService: TripService,
            analytics,
            private basketService,
            private broker: Core.Broker
        ) {

            tripService.getTrip($routeParams.tripId).then((trip: TripState) => {
                this.tripId = trip.TripId;
                this.basketId = trip.BasketId;
                this.broker.subscribe('HotelsOptions', 'basketUpdated', () => {
                    this._updateCostBreakdown(this.basketId)();
                });

                $q.all([
                    basketStore.all(this.basketId, $routeParams.productId),
                    basketStore.costBreakdown(this.basketId, $routeParams.productId),
                    basketStore.rules(this.basketId, $routeParams.productId),
                    basketStore.totalDeposit(this.basketId, $routeParams.productId),
                    basketStore.optionConditions(this.basketId),
                    basketStore.totalCost(this.basketId),
                    basketStore.payDirectTotal(this.basketId),
                    basketStore.payments(this.basketId),
                    tripService.getTripReducedOccupancy(this.tripId)
                ]).then(results => {
                    this.attractionsExtraEnabled = (!!TRPCONFIG.Domain.AttractionsExtraEnabled
                        || !!TRPCONFIG.Domain.AttractionsExtraMobileEnabled);
                    let [products, costBreakdown, rules, totalDeposit,
                        optionConditions, totalCost, paydirectTotal, payments, occupancy] = results;

                    this.hotel = products.h;
                    this.transfer = products.t;
                    this.costBreakdown = costBreakdown;
                    this.optionConditions = optionConditions;
                    this.totalCost = totalCost;
                    this.payDirectAmount = paydirectTotal;
                    this.paymentData = payments;
                    this.basketRules = rules;
                    this.totalDeposit = totalDeposit;

                    this.children = (occupancy.ChildAges && occupancy.ChildAges.length) || 0;

                    $rootScope.unlockScreen($scope);

                    analytics.track('Event', 'OptionsPage', {
                        TotalCost: this.totalCost,
                        Hotel: this.hotel,
                    });

                    if (trip.HotelsRequest) {
                        tripService.getDurationSummary(searchUnitService.hotel, $routeParams.tripId)
                            .then(ds => this.durationSummary = ds);
                        this.additionalInformation = this.hotel.Details.AdditionalInformation
                            .concat(this.hotel.Details.PromotionalInformation);
                    }

                    this.loading = false;

                });
            });
        }

        private _updateCostBreakdown(basketId) {
            return () => {
                return this.$q.all([this.basketStore.costBreakdown(basketId, this.$routeParams.productId),
                    this.basketStore.totalDeposit(basketId, this.$routeParams.productId),
                    this.basketStore.totalCost(basketId),
                    this.basketStore.payDirectTotal(basketId),
                    this.basketStore.payments(basketId)]
                ).then(res => {
                    this.costBreakdown = res[0];
                    this.totalDeposit = res[1];
                    this.totalCost = res[2];
                    this.payDirectAmount = res[3];
                    this.paymentData = res[4];
                });
            };
        }

        book () {
            this.submitted = true;
            this.basketService.bookHotelBasket(this.tripId);
        }

    }

    angular
        .module('TR')
        .controller('HotelOptions', HotelOptions);

}
